// Admin panel has no runtime feature-flag service, so gating is build-time
// Vite env vars (baked per environment from the .env templates). Flipping
// either flag requires editing the template and rebuilding/redeploying the
// admin panel (see KA-1934).

// KA-1511: org health-check UI (panel, wizard, auto-open, legacy HealthSelect swap)
// and the Kintsugi CX board (/kintsugi-cx — KA-2004). Both surfaces share this flag;
// there is no separate CX-board env var.
export const isOrgHealthCheckEnabled = (): boolean => import.meta.env.VITE_ORG_HEALTH_CHECK_ENABLED === 'true';

// KA-1934: Kintsugi Tasks board sidebar + /kintsugi-tasks route. Independent of
// health-check so billing-change-request work can ship before health checks.
export const isKintsugiTasksBoardEnabled = (): boolean => import.meta.env.VITE_KINTSUGI_TASKS_BOARD_ENABLED === 'true';

// KA-2183: CSM Workspace sidebar + /csm route. A kill switch only: who can see the page is
// the can_view_csm_workspace permission (KA-2260), because the health-check flag is on for all admins.
export const isCsmWorkspaceEnabled = (): boolean => import.meta.env.VITE_CSM_WORKSPACE_ENABLED === 'true';

// Admin profile rollout: enabled in the development build for pre-release testing
// and disabled in the production build until release approval.
export const isAdminProfileEnabled = (): boolean => import.meta.env.VITE_ADMIN_PROFILE_ENABLED === 'true';

// Filing error report rollout: enabled in the development build for pre-release testing
// and disabled in the production build until release approval. The backend flag is the real
// gate; this one only hides the UI.
export const isFilingErrorReportEnabled = (): boolean => import.meta.env.VITE_FILING_ERROR_REPORT_ENABLED === 'true';
